export default "__VITE_ASSET__4293b12f__"